import React from "react";
import className from "classnames/bind";
import styles from "../OrderInfoPage.module.scss";
import useTranslations from "../../../hooks/useTranslations";
import { translateProductName } from "../../../utils/translateProductName";

const cx = className.bind(styles);

const OrderSummary = ({
  checkoutProducts,
  formatPrice,
  subtotal,
  shippingCost,
  total,
  handleSubmit,
  isSubmitting,
  orderSuccess,
  formData,
}) => {
  const translations = useTranslations();

  return (
    <div className={cx("order-summary")}>
      <h3>{translations?.OrderReview?.order_total || "Order Total"}</h3>
      <div className={cx("summary-items")}>
        {checkoutProducts.map((item, index) => (
          <div key={item.id} className={cx("summary-item")}>
            <span>
              {index + 1}. {translateProductName(item.name)}
            </span>
            <span>{formatPrice(item.price * item.quantity)}</span>
          </div>
        ))}
      </div>
      <div className={cx("summary-row")}>
        <span>{translations?.OrderReview?.subtotal || "Subtotal"}</span>
        <span>{formatPrice(subtotal)}</span>
      </div>
      <div className={cx("summary-row")}>
        <span>{translations?.Order?.shipping_fee || "Shipping"}</span>
        <span>{translations?.Checkout?.free || "free"}</span>
      </div>
      <div className={cx("summary-total")}>
        <span>{translations?.OrderReview?.total || "Total"}</span>
        <span>{formatPrice(total)}</span>
      </div>
      <button
        type="submit"
        onClick={() => handleSubmit()}
        className={cx("submit-btn", { loading: isSubmitting })}
        disabled={isSubmitting}
      >
        {isSubmitting ? (
          <span className={cx("loading-text")}>
            {orderSuccess ? (
              "✅ Đặt hàng thành công! Đang chuyển hướng..."
            ) : formData.paymentMethod === "cod" ? (
              "Đang xử lý đơn hàng..."
            ) : (
              "Đang xử lý thanh toán..."
            )}
          </span>
        ) : (
          <>
            {formData.paymentMethod === "cod"
              ? `${translations?.OrderReview?.purchase || "PLACE ORDER"} (${
                  translations?.Checkout?.cod || "COD"
                })`
              : formData.paymentMethod === "paypal"
              ? `${translations?.OrderReview?.purchase || "PAY"} WITH ${
                  translations?.Checkout?.paypal || "PAYPAL"
                }`
              : formData.paymentMethod === "vnpay_visa"
              ? translations?.Checkout?.pay_with_vnpay || "PAY WITH VNPAY"
              : translations?.OrderReview?.purchase || "PLACE ORDER"}
          </>
        )}
      </button>
    </div>
  );
};

export default OrderSummary;
